import type { FunctionComponent } from 'react';

import useLogout from 'hooks/useLogout';

const LogoutPage: FunctionComponent = function () {
  localStorage.removeItem('__ksp_visited__');
  useLogout();
  return <span />;
};

export default LogoutPage;
